export default __webpack_public_path__ + "static/media/preview.6ec62f0b.svg";